import { useEffect, useState } from 'react'
import type { Socket } from 'socket.io-client'
import { socketService } from '../shared/application/socket.service'
import { useSessionStore } from './use_session_store'

export function useSocket() {
  const { user } = useSessionStore()
  const [socket, setSocket] = useState<Socket | null>(null)
  useEffect(() => {
    if (user) {
      const socketInstance = socketService.getSocket(user)
      if (socketInstance) setSocket(socketInstance)
    }
  }, [user])
  return socket
}
